import React, { forwardRef } from 'react';
import { classNames } from '../../utils/style';
import { PopoverArrow } from './PopoverArrow';
import { fontCaption } from '../../styles/typographyNew';
import { Icon } from '../Picto/Icon';
import { PopupContentProps } from './types';
export const PopupContent = forwardRef(function PopupContent(
  {
    closePopup,
    position,
    className,
    id,
    children,
    isHoverable,
    modalOnMediumScreen,
  }: PopupContentProps,
  ref: React.Ref<HTMLDivElement>,
) {
  return (
    <div
      ref={ref}
      tabIndex={-1}
      id={`popup_content_${id}`}
      role="region"
      aria-live="polite"
      className={classNames(
        'PopupContent',
        'bg-white',
        'text-black',
        'p-[24px]',
        fontCaption,
        'border-[#E9EBEE]',
        /** Styles de débogage */
        'min-width-[200px]',
        'min-height-[100px]',
        /** mobile */
        'rounded-t-[16px] border-t',
        'fixed bottom-0 left-0 right-0',
        /** Desktop */
        !modalOnMediumScreen &&
          classNames('md:rounded-[16px] md:border', 'md:relative md:shadow-m'),
        modalOnMediumScreen &&
          classNames('lg:rounded-[16px] lg:border', 'lg:relative lg:shadow-m'),
        className,
      )}
    >
      <PopoverArrow
        position={position}
        className={classNames('popoverArrow absolute', 'hidden md:block')}
      />
      {!isHoverable && (
        <button
          onClick={closePopup}
          className="absolute right-[8px] top-[8px]"
          aria-label="Close"
        >
          <Icon name="clear" className="h-[23px] w-[23px]" />
        </button>
      )}
      {children}
    </div>
  );
});
